import Decimal from 'decimal.js';

const DISPLAY_AS_EXPONENTIAL_THRESHOLD = new Decimal('1e21');
/**
 * Format a number to show at most 10 digits after the decimal point, with no trailing zeroes.
 *
 * NOTE: Edits to this function must be reflected in
 * benchling/notebook/structured_tables/export/typed_value:pretty_float.
 */
function prettyFloat(number: number, precision: number | null = null): string {
  const val = new Decimal(number);
  if (precision != null) {
    return val.toFixed(precision);
  }

  // Remove trailing 0s by matching decimal part of a number, capturing part to be preserved as $1.
  // We either match:
  // - decimal with all 0's, e.g. 100[.000000] without capture to remove all, OR
  // - up to where it it ends in trailing zeroes, e.g. 100[(.01)00000, capturing .01 to preserve it
  // Because we're using Decimal.js, we need to recreate JavaScript's heuristic for when to display the
  // value in scientific notation due to it's size.
  // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toFixed
  if (val.abs().greaterThan(DISPLAY_AS_EXPONENTIAL_THRESHOLD)) {
    return val.toExponential().replace(/\.0+$|(\.\d*[1-9])0+$/, '$1');
  } else {
    return val.toFixed(10).replace(/\.0+$|(\.\d*[1-9])0+$/, '$1');
  }
}

export default prettyFloat;
